<template>
  <div role="group" class="form-group">
    <label :class="!hideLabel ? '' : 'sr-only'" :for="groupId" v-text="!hideLabel ? label : placeholder">
    </label>
    <input
      :id="groupId"
      v-model.trim="inputValue"
      type="text"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      class="form-control"
      :class="{ 'promo-code': promoCode, 'is-invalid': state === false }"
      :promo-code="promoCode"
      :aria-invalid="!state"
      :autocomplete="autocomplete"
      @change="change"
      @blur="blur"
    />
    <span class="invalid-feedback">{{ errorText }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      hideLabel: {
        type: [Boolean, String],
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      groupId: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: 'Placeholder'
      },
      state: {
        type: Boolean,
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      },
      errorText: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      modelValue: {
        type: String,
        default: ''
      },
      promoCode: {
        type: Boolean,
        default: false
      },
      autocomplete: {
        type: String,
        default: 'off'
      }
    },
    computed: {
      inputValue: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
          this.$emit('inputed', value);
        }
      }
    },
    methods: {
      change() {
        this.$emit('changed', this.modelValue);
      },
      blur() {
        this.$emit('blured', this.modelValue);
      }
    }
  };
</script>
<style lang="scss" scoped>
  input.form-control {
    &.promo-code {
      border-radius: 4px;
      &::placeholder {
        color: var(--transparent-light-medium);
      }
    }
  }
  label {
    font-size: $h6-font-size;
  }
</style>
